'use strict';
module.exports = require('./Galleria.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/galleria/index.js
// module id = 60
// module chunks = 1